import { useRouter } from '@/utils/vue-api';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { CACHE_APP_ENTRY_URL } from '@/const/host';
import LoadingMask from '@rebuild/components/loading/loading';
import { useCommonData } from './useCommonData';
import { usePageWithLanguage } from '@rebuild/materials/shared/layout_nav/surf/usePageWithLanguage';
import i18n from '@/locales';

export const useRedirect = () => {
	const router = useRouter();
	const { isSurfTmpl } = useCommonData();
	const { findIndexPageInfoByLanguage } = usePageWithLanguage();

	const showFullscreenLoading = () => {
		LoadingMask.show();
	};

	const { buildTemplateQuery, buildTemplatePath } = useNavigation();
	const buildHomePathInRoot = () => buildTemplatePath('index');
	const buildHomePathInSurfPage = lang => {
		// 由于翻页卡片没有首页概念，所以切换语言的时候需要出模拟一个首页场景 ——> /page/第一个菜单的菜单ID
		const indexPageInfo = findIndexPageInfoByLanguage(lang);
		const path = `page/${indexPageInfo?.indexUuid || ''}`;
		return buildTemplatePath(path);
	};

	const replaceLocationToHome = lang => {
		showFullscreenLoading();

		const query = buildTemplateQuery();
		if (lang) {
			query.lang = lang;
		} else {
			query.lang = i18n.locale;
		}

		const buildIndexPath = isSurfTmpl.value ? buildHomePathInSurfPage(query.lang) : buildHomePathInRoot();
		const targetRoute = {
			path: buildIndexPath,
			query: query
		};
		const targetUrl = router.resolve(targetRoute).href;
		window.location.replace(targetUrl);
	};

	const checkEntryUrl = () => {
		const entryUrl = sessionStorage.getItem(CACHE_APP_ENTRY_URL);
		if (entryUrl) return entryUrl;
		return null;
	};
	const replaceToEntryUrl = (url, nextLang) => {
		showFullscreenLoading();
		const urlObj = new URL(url);
		if (nextLang) {
			urlObj.searchParams.set('lang', nextLang);
		}
		window.location.replace(urlObj.toString());
	};
	const replaceLocation = () => {
		showFullscreenLoading();
		location.reload();
	};

	return {
		checkEntryUrl,
		replaceToEntryUrl,
		replaceLocation,
		replaceLocationToHome
	};
};
